import { useEffect } from 'react';
import { useTariffStore } from '@lib/store';
import { PageLayout } from '@shared/widgets';
import { TariffList, TariffTable } from './widgets';
import TariffIcon from '@assets/images/tariff_ico.svg';

export const TariffPage = () => {
  const { data, getTariff } = useTariffStore();

  useEffect(() => {
    getTariff();
  }, []);

  return (
    <PageLayout>
      <div className='mx-auto max-w-[1440px] max-md:w-auto max-md:pt-[27px]'>
        <TariffIcon className='mx-auto mb-10 hidden max-md:block' />
        <div className='mt-[90px] mb-7.5 flex items-center max-md:m-0 max-md:mb-4'>
          <div className='h-[1px] w-[140px] bg-[#272727] max-md:hidden' />
          <h2 className='ml-6 font-[Prata] text-[56px] text-[#272727] max-md:relative max-md:mx-auto max-md:px-6 max-md:text-center max-md:text-[28px]'>
            Schedule of Fees and Charges
          </h2>
        </div>
        <p className='mb-[53px] ml-[163px] w-[329px] text-lg font-light text-[#4c4c4c] max-md:mx-6 max-md:my-0 max-md:w-auto max-md:text-center max-md:text-[#4c4c4c80]'>
          Enter our world of crafted benefits to assist the lifes of our UNHW client base.
        </p>
        {data && <TariffTable className='max-md:!hidden' tariffs={data} />}
        {data && <TariffList className='!hidden max-md:!block' tariffs={data} />}
      </div>
    </PageLayout>
  );
};
